{
  "name": "@uzysjung/agent-harness",
  "version": "26.99.0",
  "description": "Curate vetted AI-coding skills & plugins by your tech stack — install only what you need, across Claude Code, Codex, OpenCode & Antigravity",
  "type": "module",
  "publishConfig": {
    "access": "public"
  },
  "engines": {
    "node": ">=20.0.0"
  },
  "bin": {
    "agent-harness": "./dist/index.js"
  },
  "files": [
    "dist",
    "templates",
    "scripts/prune-ecc.sh",
    "README.md",
    "LICENSE"
  ],
  "scripts": {
    "build": "tsup",
    "dev": "tsup --watch",
    "gen:compat": "npm run build && node scripts/gen-compatibility.mjs",
    "test": "vitest run",
    "test:watch": "vitest",
    "test:coverage": "vitest run --coverage",
    "typecheck": "tsc --noEmit",
    "lint": "biome check src tests",
    "lint:fix": "biome check --write src tests",
    "format": "biome format --write src tests",
    "ci": "npm run typecheck && npm run lint && npm run test:coverage && npm run build",
    "prepare": "[ -d dist ] || npm run build"
  },
  "dependencies": {
    "@clack/prompts": "^1.3.0",
    "cac": "^7.0.0"
  },
  "devDependencies": {
    "@biomejs/biome": "^2.4.13",
    "@types/node": "^25.6.0",
    "@vitest/coverage-v8": "^2.1.0",
    "tsup": "^8.3.0",
    "typescript": "^5.6.0",
    "vitest": "^2.1.0"
  },
  "license": "MIT",
  "repository": {
    "type": "git",
    "url": "git+https://github.com/uzysjung/uzys-agent-harness.git"
  }
}
